import { cn } from "@/lib/utils";
import { forwardRef } from "react";

interface ToolbarButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  rightIcon?: React.ReactNode;
  /** 라벨을 좌측 정렬하고 우측 아이콘을 끝으로 밀지 여부 (드롭다운 트리거용) */
  spread?: boolean;
}

// ============================================
// ToolbarButton
// 보고서 목록 툴바의 아웃라인 버튼(종류 · 정렬 등) 공통 스타일.
// ============================================

export const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  ({ rightIcon, spread, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        "flex h-9 items-center gap-2 rounded-md border border-neutral-200 bg-white px-4",
        "label-1-normal-medium text-label-normal transition-colors hover:bg-neutral-50",
        className,
      )}
      {...props}
    >
      <span className={cn("truncate", spread && "flex-1 text-left")}>
        {children}
      </span>
      {rightIcon && <span className="flex shrink-0 items-center">{rightIcon}</span>}
    </button>
  ),
);

ToolbarButton.displayName = "ToolbarButton";
